import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import t from 'tcomb-form';
import { WebsiteRefinement, EmailRefinement } from '../utils/tcomb-utils';
import { isUrl } from '../utils/index';


const LinkedIn = t.refinement(t.String, (url) => {
  return (isUrl(url) && url.indexOf('linkedin.com') != -1) ? true : false;
});

const Facebook = t.refinement(t.String, (url) => {
  return (isUrl(url) && url.indexOf('facebook.com') != -1) ? true : false;
});

const Twitter = t.refinement(t.String, (url) => {
  return (isUrl(url) && url.indexOf('twitter.com') != -1) ? true : false;
});


const OrgConnectSchema = t.struct({
  website: t.maybe(WebsiteRefinement),
  twitter: t.maybe(Twitter),
  facebook: t.maybe(Facebook),
  linkedin: t.maybe(LinkedIn),
  email: t.maybe(EmailRefinement),
  us_phone: t.maybe(t.String),
  intl_phone: t.maybe(t.String)
});


const formOptions = {
  auto: 'none',
  fields: {
    website: {
      error: 'Please provide a valid website address or url',
      attrs: {
        placeholder: 'Website'
      }
    },
    twitter: {
      error: 'Please provide a valid Twitter URL',
      attrs: {
        placeholder: 'Twitter'
      }
    },
    facebook: {
      error: 'Please provide a valid Facebook URL',
      attrs: {
        placeholder: 'Facebook'
      }
    },
    linkedin: {
      error: 'Please provide a valid LinkedIn URL',
      attrs: {
        placeholder: 'LinkedIn'
      }
    },
    email: {
      error: 'Please provide a valid email address',
      type: 'email',
      attrs: {
        placeholder: 'Email'
      }
    },
    us_phone: {
      attrs: {
        placeholder: 'US Phone'
      }
    },
    intl_phone: {
      attrs: {
        placeholder: 'International Phone'
      }
    }
  }
};

export default class OrganizationDetailConnectSection extends Component {
  state = {
    formOptions: formOptions,
    formValue: {},
    showEditFields: false
  };

  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
    const { organization } = nextProps
    if(!organization.db_id) {
      return;
    }
    const { formValue } = this.state;
    this.setState({ formValue: {
      website: formValue.website || organization.website,
      facebook: formValue.facebook || organization.facebook,
      twitter: formValue.twitter || organization.twitter,
      linkedin: formValue.linkedin || organization.linkedin,
      email: formValue.email || organization.email,
      us_phone: formValue.us_phone || organization.us_phone,
      intl_phone: formValue.int_phone || organization.intl_phone
    }});
  }

  onFormChange = formValue => {
    this.setState({formValue});
  };

  handleSubmit = e => {
    e.preventDefault();
    const value = this.refs.connectForm.getValue();
    if(!value) {
      //
    }
    else {
      for(const key in value) {
        const val = this.state.formValue[key];
        if(val) {
          this.props.updateContent(key, val);
        }
      }
      this.hideEditFields(e);
    }
  };

  showEditFields = e => {
    e.preventDefault();
    this.setState({ showEditFields: true });
  };

  hideEditFields = e => {
    e.preventDefault();
    this.setState({ showEditFields: false });
  };

  cancelEdit = e => {
    this.setState({ formValue: {}});
  };

  formatUSPhone = (s) => {
    var s2 = (""+s).replace(/\D/g, '');
    var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
    return (!m) ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
  }

  render() {
    const { organization, isEditMode, sectionTitle, cssSuffix } = this.props;

    let connectSection = [];
    let formFields = [];
    let editIcon = '';
    let content = '';

    let website = this.state.formValue.website || organization.website;
    let twitter = this.state.formValue.twitter || organization.twitter;
    let facebook = this.state.formValue.facebook || organization.facebook;
    let instagram = this.state.formValue.instagram || organization.instagram;
    let linkedin = this.state.formValue.linkedin || organization.linkedin;
    let email = this.state.formValue.email || organization.email;
    let us_phone= this.state.formValue.us_phone || organization.us_phone;
    let intl_phone = this.state.formValue.intl_phone || organization.intl_phone;

    let formatted_us_phone = this.formatUSPhone(us_phone);


    if(website) {
      connectSection.push(<li><a target="_blank" href={website}><i className="fa fa-globe"></i> Website</a></li>);
    }

    if(twitter) {
      connectSection.push(<li><a target="_blank" href={twitter}><i className="fa fa-twitter"></i> Twitter</a></li>);
    }

    if(facebook) {
      connectSection.push(<li><a target="_blank" href={facebook}><i className="fa fa-facebook"></i> Facebook</a></li>);
    }

    if(instagram) {
      connectSection.push(<li><a target="_blank" href={instagram}><i className="fa fa-instagram"></i> Instagram</a></li>);
    }

    if(linkedin) {
      connectSection.push(<li><a target="_blank" href={linkedin}><i className="fa fa-linkedin"></i> LinkedIn</a></li>);
    }

    if(email) {
      connectSection.push(<li><a href={'mailto:' + email}><i className="fa fa-envelope-o"></i> Email</a></li>);
    }

    if(formatted_us_phone) {
      connectSection.push(<li><a target="_blank" href={'call:' + us_phone}><i className="fa fa-phone"></i> {formatted_us_phone}</a></li>);
    }

    if(intl_phone) {
      connectSection.push(<li><a target="_blank" href={'call:' + intl_phone}><i className="fa fa-phone"></i> {intl_phone}</a></li>);
    }


    if(isEditMode) {
      editIcon = <span onClick={this.showEditFields} className="organization-editIcon">
        <i className="fa fa-pencil"></i>
      </span>;
      formFields = <div>
        <t.form.Form ref="connectForm"
                                value={this.state.formValue}
                                onChange={this.onFormChange}
                                type={OrgConnectSchema}
                                options={this.state.formOptions} />
      <div><button type="submit" onClick={this.handleSubmit}>Save</button> <button onClick={this.hideEditFields}>Cancel</button></div>
      </div>;
    }

    if(this.state.showEditFields) {
      content = formFields;
    }
    else {
      content = connectSection;
    }



    return <div className="organizationDetail-connect">
      <div className="organizationDetail-connectTitle">connect {editIcon}</div>
      <div className="organizationDetail-connectDescription">
        <ul className="organizationDetail-connectList">
          {content}
        </ul>
      </div>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/OrganizationDetailConnectSection.jsx